import { Button, Card, DatePicker, Divider, Form, Space, Statistic } from 'antd'
import React, { useEffect, useState } from 'react'
import service from '../../../@services'
import PaymentListTable from '../components/PaymentListTable'
import BasicForm from '../components/BasicForm'
import SelectStores from '../components/SelectStores'
import Selector from '../components/Selector'
import { useLocation } from 'react-router'
import moment from 'moment'
import * as Utils from '../../../@utils'
const { RangePicker } = DatePicker

/**
 * @param {Object} values 需要格式化的对象
 * @param {String} formatStr 格式化样式 默认'YYYY-MM-DD HH:mm:ss'
 * @returns Object
 */
const format = (values, formatStr = 'YYYY-MM-DD HH:mm:ss') => {
  if (!values) return {}
  values.beginCreateTime = values.createTime
    ? values.createTime[0].format(formatStr)
    : null
  values.endCreateTime = values.createTime
    ? values.createTime[1].format(formatStr)
    : null
  values.beginTradeTime = values.tradeTime
    ? values.tradeTime[0].startOf('day').format(formatStr)
    : null
  values.endTradeTime = values.tradeTime
    ? values.tradeTime[1].endOf('day').format(formatStr)
    : null
  return { ...values }
}

const PaymentList = ({ history }) => {
  const { state } = useLocation()
  const initialValues = {
    createTime: [
      state && state.createTime && moment(state.createTime[0]),
      state && state.createTime && moment(state.createTime[1]).endOf('day'),
    ],
  }
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    pageIndex: 1,
    pageSize: 20,
    ...format(state && state.createTime && initialValues),
  })
  const [summary, setSummary] = useState({})
  const [total, setTotal] = useState(0)
  const [list, setList] = useState([])
  /** 表单筛选项字段及组件 */
  const fields = [
    {
      label: '供应门店',
      name: 'storeCode',
      component: <SelectStores isString allowClear />,
    },
    { label: '收银员', name: 'employee', placeholder: '收银员工号或名称' },
    { label: '收银机编码', name: 'posId', placeholder: '收银机编码' },
    { label: '缴款单单号', name: 'payinSlipNo', placeholder: '缴款单单号' },
    {
      label: '缴款类型',
      name: 'payTypeCode',
      component: <Selector tag="payTypes" mode="" />,
    },
    {
      label: '审核标识',
      name: 'status',
      component: <Selector tag="status" mode="" />,
    },
    {
      label: '销售发生日期',
      name: 'tradeTime',
      component: (
        <RangePicker allowClear placeholder={['开始日期', '结束日期']} />
      ),
    },
    {
      label: '缴款单生成日期',
      name: 'createTime',
      component: (
        <RangePicker
          showTime
          allowClear
          placeholder={['开始日期', '结束日期']}
        />
      ),
    },
  ]
  /** 获取缴款单明细列表 */
  const getPayinSlipList = () => {
    setLoading(true)
    service.order
      .getPayinSlipList({ ...formData })
      .then((res) => {
        setLoading(false)
        let { result, data, recordCount } = res || {}
        setList(result || [])
        setSummary(data || {})
        setTotal(recordCount || 0)
      })
      .catch((e) => {
        setLoading(false)
      })
  }
  /** 查询 */
  const submit = (values) => {
    let formatValues = format(values)
    setFormData({ ...formData, ...formatValues })
  }
  /** 导出 */
  const onExport = async (values) => {
    let formatValues = format(values)
    setFormData({ ...formData, ...formatValues })
    let file = await service.order.exportPayinSlip({
      ...formData,
      ...formatValues,
    })
    const filename =
      '缴款单明细报表' + Utils.parseTime(Date.parse(new Date())) + '.xlsx'
    Utils.download(file, filename)
  }
  /** 返回上一级 */
  const onBack = () => {
    history.goBack()
  }
  useEffect(() => {
    getPayinSlipList()
  }, [formData])
  return (
    <div className="payment-list-page">
      <BasicForm
        name="payment-list"
        fields={fields}
        onSearch={submit}
        onExport={onExport}
        authKey={{
          search: '/payin/payin-slip/item/list',
          export: '/payin/payin-slip/item/export',
        }}
      >
        <Form.Item>
          <Button type="primary" onClick={onBack}>
            返回
          </Button>
        </Form.Item>
      </BasicForm>
      <Card>
        <Space
          className="total-box"
          size="large"
          split={<Divider type="vertical" />}
        >
          <Statistic title="缴款单金额(元)" value={summary.totalAmount || 0} />
          <Statistic
            title="已审核缴款单金额(元)"
            value={summary.verifiedAmount || 0}
          />
        </Space>
        <PaymentListTable
          loading={loading}
          list={list}
          total={total}
          page={formData}
          submit={(pages = {}) => setFormData({ ...formData, ...pages })}
        />
      </Card>
    </div>
  )
}
export default PaymentList
